import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PracticalExerciseWrapper = ({
  buttons,
  children,
  illustrationName,
  statusSubtitleNode,
  statusTitleI18n
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "practical-exercise-wrapper",
    children: [/*#__PURE__*/_jsx(View, {
      blockSize: "100%",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsxs(Flex, {
        blockSize: "100%",
        justifyContent: "center",
        paddingInlineEnd: "250",
        children: [!isMobile && /*#__PURE__*/_jsxs(Flex, {
          blockSize: "100%",
          flexDirection: "column",
          justifyContent: "start",
          margin: "0",
          paddingBlockStart: "1000",
          paddingInlineEnd: "500",
          paddingInlineStart: "1000",
          children: [/*#__PURE__*/_jsx(Illustration, {
            maxBlockSize: "140px",
            name: illustrationName,
            paddingBlockEnd: "600"
          }), statusTitleI18n && /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginBlockEnd: "100",
            textAlign: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: statusTitleI18n
            })
          }), /*#__PURE__*/_jsx(Text, {
            textAlign: "center",
            children: statusSubtitleNode
          })]
        }), /*#__PURE__*/_jsx("div", {
          children: children
        })]
      })
    }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
      children: buttons
    })]
  });
};
export default PracticalExerciseWrapper;